import { useMutation } from '@tanstack/react-query';

import { getApiHostHeaders, requireApiBaseUrl } from '@/lib/api-url';
import { appendCompressedImage } from '@/lib/image-upload';
import { useAuthStore } from '@/store/authStore';
import { User } from '@/types/user';
import { getFetchErrorMessage } from '@/utils/api-error';

/**
 * Foto do usuário (multipart, igual ao logo/capa). O store é atualizado aqui
 * porque o avatar aparece na sidebar e no cabeçalho, não só na tela que
 * enviou a foto.
 */
export function useUploadAvatar() {
  return useMutation({
    mutationFn: async (imageUri: string) => {
      const formData = new FormData();
      await appendCompressedImage(formData, 'file', imageUri, 'avatar');

      const API_URL = requireApiBaseUrl().replace(/\/$/, '');
      const token = useAuthStore.getState().token;

      const response = await fetch(`${API_URL}/user/avatar`, {
        method: 'POST',
        body: formData,
        headers: {
          Accept: 'application/json',
          Authorization: `Bearer ${token}`,
          ...getApiHostHeaders(),
        },
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(getFetchErrorMessage(response.status, errorData, 'Erro ao enviar foto.'));
      }

      return (await response.json()) as User;
    },
    onSuccess: (updated) => {
      const current = useAuthStore.getState().user;
      if (current) {
        useAuthStore.getState().setUser({ ...current, image: updated.image });
      }
    },
  });
}
